export default __webpack_public_path__ + "static/media/cecosam-logo.a819cf3b.png";